<template>
  <transition
    appear
    @enter="5600"
    @leave="2000"
    name="fade"
    mode="out-in"
    >
    <div class="processing">
      <div
        class="processing-wrapper"
        >
        <div class="falling-object" v-for="n in 10" :key="n"></div>
        <img
          :src='bag'
          ref="bag"
          class="bag"
          >
      </div>
    </div>
  </transition>
</template>
<script>
import { TweenMax, Linear } from 'gsap'

export default {
  name: 'processing',
  props: {
    eanupc: {
      type: String,
      default: '123456789101',
      require: true
    }
  },
  data () {
    return {
      interval: null,
      progressValue: 0
    }
  },
  methods: {
    getObjectClassName (n) {
      let i = n % 3 + 1
      let className = `object-${i}`
      className += n % 2 ? '' : ' offset'
      className += ' falling-object'
      return className
    },
    animate () {
      let objects = this.$el.querySelectorAll('.falling-object')
      let bagBounds = this.$refs.bag.getBoundingClientRect()

      objects.forEach((el, n) => {
        el.className = this.getObjectClassName(n)
        TweenMax.to(el, 4, {
          top: bagBounds.top + bagBounds.height / 3,
          ease: Linear.easeNone,
          delay: n * 0.4,
          repeat: -1
        })
      })
    },
    stopTimer () {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    },
    startTimer () {
      let step = Math.round(Math.random() * 30)
      this.interval = setInterval(() => {
        if (this.progressValue > 30 && this.progressValue < 70) {
          step = Math.round(Math.random() * 5)
        } else if (this.progressValue > 70 && this.progressValue < 100) {
          step = Math.round(Math.random() * 1)
        } else if (this.progressValue > 0 && this.progressValue < 30) {
          step = Math.round(Math.random() * 15)
        }
        this.progressValue += step
        if (this.progressValue >= 100) {
          this.stopTimer()
          this.$router.push('/thanks')
        }
      }, 1500)
    }
  },
  computed: {
    bag () {
      return require(`@/assets/bag.png`)
    }
  },
  mounted () {
    console.log(`USER: DISPENSES: ${this.eanupc}`)
    this.$api.dispense(this.eanupc).then(ans => {
      if (ans) this.$router.push('/thanks')
    }).catch(err => {
      console.log(err.response.data.result)
      this.$router.push({ name: 'errors',
        params: {
          message: err.response.data.message,
          result: err.response.data.result
        }
      })
    })
    this.startTimer()
    this.$nextTick(() => {
      this.animate()
    })
  },
  beforeDestroy () {
    this.stopTimer()
  }
}
</script>
<style lang="scss" scoped>
  .processing {
    background:  #fff;
    background-color: #fff;
    width: 100vw;
    height: 100vh;
    z-index: 1200;

    .processing-wrapper {
      width: 100vw;
      z-index: 1200;
      height: 100vh;
      position: absolute;
      background: #fff;
      background-color: #fff;
      left: 0;
      top: 0;
    }

    .progress-bar {
      top: 90%;
      display: none;
    }
    .falling-object {
      position: absolute;
      left: 47%;
      transform: translateX(-50%);
      margin-left: -20px;
      top: -200px;

      &.offset {
        margin-left: 70px;
      }

      &.object-1 {
        width: 64px;
        height: 104px;
        background: url('../../assets/object-10.png') 0 0 no-repeat;
        background-size: contain;
      }
      &.object-2 {
        width: 64px;
        height: 104px;
        background: url('../../assets/object-11.png') 0 0 no-repeat;
        background-size: contain;
      }
      &.object-3 {
        width: 64px;
        height: 104px;
        background: url('../../assets/object-12.png') 0 0 no-repeat;
        background-size: contain;
      }
    }
    .bag {
      width: 265px;
      background-size: contain;
      position: absolute;
      z-index: 10;
      left: 50%;
      top: 80%;
      margin-top: -50px;
      transform: translate(-50%, -50%);
    }
  }
</style>
